<template>
  <q-page v-if="selectedOutcome" :style="cssVars">
    <div class="row full-width">
      <div style="width: 75%">
        <div class="q-pa-none">
          <div class="row full-width">
            <div style="width: 100%">
              <topbar
                :title="
                  currentUserData.sustainabilityBusiness_name
                    ? currentUserData.sustainabilityBusiness_name
                    : 'Test Business'
                "
                :titleColor="cssVars['--outcome-secondary']"
                :backgroundColor="cssVars['--outcome-primary']"
              >
                <template v-slot:content>
                  <div class="row">
                    <div class="col">
                      <div class="row">
                        <span
                          :style="`color: ${cssVars['--outcome-secondary']}`"
                          class="title"
                        >
                          {{
                            currentUserData.sustainabilityBusiness_name
                              ? currentUserData.sustainabilityBusiness_name
                              : "Test Business"
                          }}
                        </span>
                      </div>
                      <div class="row justify-between item-center">
                        <div class="row items-center q-mt-none">
                          <span class="dropdownTitle text-white">
                            Data Goal Setting for
                          </span>
                          <sustainability-dropdown
                            :model="selectedOutcome"
                            class="q-ml-sm"
                            :style="`
                      background-color: ${cssVars['--outcome-secondary']};
                      border-radius: 5px;
                      `"
                            :options="outcomesList"
                            :isObjects="true"
                            objectKey="label"
                            @input="selectOutcome"
                          ></sustainability-dropdown>
                          <div class="q-ml-sm">
                            <year-picker
                              :initial-year="selectedYear"
                              ref="yearPicker"
                              label="for"
                              @selectYear="checkCalendar"
                              :bg="cssVars['--outcome-secondary']"
                            ></year-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-auto"
                      v-if="selectedOutcome.usesFactor == 1"
                      style="
                        position: relative;
                        min-width: 260px;
                        max-width: 260px;
                      "
                    >
                      <summary-stats-card
                        style="position: absolute; top: -17px; right: -17px"
                        :bg="cssVars['--outcome-secondary']"
                        :slides="summaryStatsCardSlides"
                        @setOverallTarget="setOverallTarget"
                      />
                    </div>
                  </div>
                </template>
              </topbar>
            </div>
          </div>
        </div>
        <div class="row q-mt-md">
          <div style="width: 25%">
            <q-card
              class="shadow-10 sustainability-card-radius full-height"
              flat
            >
              <q-card-section class="q-py-none" style="padding-top: 12px">
                <span
                  class="categoryHeader"
                  :style="`color:${cssVars['--outcome-secondary']}`"
                >
                  CATEGORY
                </span>
              </q-card-section>
              <q-scroll-area
                style="height: calc(100vh - 285px)"
                :thumb-style="{
                  background: '#162c479c',
                  opacity: 1,
                  width: '8px',
                  height: '8px',
                  borderRadius: '20px',
                }"
                :visible="true"
              >
                <q-list class="q-mt-md q-pa-md">
                  <q-card
                    class="categoryCard no-shadow"
                    :class="{ cardSelected: selectedCategory == 'all' }"
                  >
                    <q-item dense @click="filterCategory('all')" clickable>
                      <span class="categoryText"> All </span>
                    </q-item>
                  </q-card>

                  <q-card
                    class="categoryCard no-shadow"
                    :class="{
                      cardSelected:
                        typeof selectedCategory === 'object'
                          ? selectedCategory.id == category.id
                          : false,
                    }"
                    @click="filterCategory(category)"
                    v-for="(category, i) in filteredCategories"
                    :key="i"
                    v-if="categoryKeys[category.id]"
                  >
                    <q-item clickable dense>
                      <div class="row justify-between items-center full-width">
                        <div class="col">
                          <span class="categoryText">
                            {{ category.name }}
                          </span>
                        </div>

                        <!-- <div class="col-shrink">
                          <span class="category-number">
                            {{
                              category != "all"
                                ? getNumberOfDataByCategory(category.id)
                                : ""
                            }}
                          </span>
                        </div> -->
                      </div>
                    </q-item>
                  </q-card>
                </q-list>
              </q-scroll-area>
            </q-card>
          </div>
          <div class="col" style="width: 75%">
            <div class="row" style="height: calc(100vh - 250px)">
              <div class="col-12">
                <q-card class="shadow-15 q-px-xs" flat>
                  <sustainability-data-table
                    style="height: calc(100vh - 250px) !important"
                    ref="datatable"
                    :data="filteredData"
                    :columns="columns"
                    @rowDoubleClick="openGoalBuilder"
                    @rowSelected="initGoalSummary"
                    updateBody
                    bodyHoverColor="#4ac7e933"
                    bodyAltColor="#F6F6F6"
                    flat
                    :hideBottom="true"
                    rowKey="sources_id"
                    :square="true"
                    separator="none"
                    headerBgColor="white"
                    :headerDark="true"
                    id="solutionsTable"
                  >
                    <!--LIST TILE LAYOUT-->
                    <template slot="body" slot-scope="data">
                      <q-tr
                        v-ripple
                        class="bg-white text-black"
                        @click="
                          $refs.datatable.handleClick(null, data.props.row)
                        "
                        @dblclick="
                          $refs.datatable.handleDoubleClick(
                            null,
                            data.props.row
                          )
                        "
                        :props="data.props"
                      >
                        <template
                          v-for="column in data.props.cols"
                          :name="`body-cell-${column.name}`"
                          v-bind:props="data.props"
                        >
                          <q-td
                            v-if="column.name == 'sourceName'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div class="sourceColumn-div">
                              <span class="sourceColumn">
                                {{ data.props.row.name }}
                                {{
                                  data.props.row.negativeLabel &&
                                  data.props.row.negative
                                    ? `(${data.props.row.negativeLabel})`
                                    : data.props.row.positiveLabel &&
                                      !data.props.row.negative
                                    ? `(${data.props.row.positiveLabel})`
                                    : ""
                                }}
                                <q-tooltip>
                                  {{ data.props.row.name }}
                                  {{
                                    data.props.row.negativeLabel &&
                                    data.props.row.negative
                                      ? `(${data.props.row.negativeLabel})`
                                      : data.props.row.positiveLabel &&
                                        !data.props.row.negative
                                      ? `(${data.props.row.positiveLabel})`
                                      : ""
                                  }}
                                </q-tooltip>
                              </span>
                            </div>
                          </q-td>

                          <q-td
                            v-else-if="column.name == 'total'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div class="totalColumn-div">
                              <span
                                class="sourceColumn"
                                style="display: inline"
                              >
                                {{ data.props.row.total | numberFormat }}
                              </span>
                              <span
                                class="totalColumn-unit text-accent"
                                style="display: inline"
                              >
                                {{ data.props.row.unit }}
                              </span>
                            </div>
                          </q-td>

                          <q-td
                            v-else-if="column.name == 'emissionsFactor'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div class="row items-center">
                              <span class="emission">
                                {{
                                  $options.filters.numberFormat(
                                    factorCalculation(
                                      !data.props.row.customEmissionsFactor ||
                                        data.props.row.customEmissionsFactor
                                          .useCustom == 0
                                        ? getTotalDefaultEmission(
                                            data.props.row
                                          )
                                        : data.props.row.customEmissionsFactor
                                        ? isNaN(
                                            parseFloat(
                                              data.props.row
                                                .customEmissionsFactor
                                                .totalValue
                                            )
                                          )
                                          ? ""
                                          : parseFloat(
                                              data.props.row
                                                .customEmissionsFactor
                                                .totalValue
                                            )
                                        : ""
                                    )
                                  )
                                }}
                              </span>
                            </div>
                          </q-td>

                          <q-td
                            v-else-if="column.name == 'actions'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <q-btn
                              no-caps
                              class="q-ma-xs"
                              unelevated
                              :color="
                                isGoalSet(data.props.row) ? 'primary' : 'grey-4'
                              "
                              style="width: 70px"
                            >
                              <span
                                :class="`buttons ${
                                  isGoalSet(data.props.row)
                                    ? 'text-white'
                                    : 'text-grey-8'
                                }`"
                              >
                                {{
                                  isGoalSet(data.props.row)
                                    ? "Goal Set"
                                    : "Goal not set"
                                }}
                              </span>
                            </q-btn>
                            <q-btn
                              no-caps
                              :class="`q-ma-xs ${
                                isGoalSet(data.props.row)
                                  ? 'bg-accent'
                                  : 'outcome-theme-secondary'
                              } text-white`"
                              style="width: 100px"
                              unelevated
                              @click="openGoalBuilder(data.props.row)"
                            >
                              <span class="buttons">
                                {{
                                  isGoalSet(data.props.row)
                                    ? "Edit this Goal"
                                    : "Goal Builder"
                                }}
                              </span>
                            </q-btn>
                          </q-td>

                          <q-td v-else :key="column.name" :props="data.props">
                            {{ column.value }}
                          </q-td>
                        </template>
                      </q-tr>
                    </template>
                  </sustainability-data-table>
                </q-card>
              </div>
            </div>
          </div>
        </div>
        <div class="row q-px-md q-pt-sm">
          <q-btn
            v-if="selectedOutcome.usesFactor == 1"
            class="bg-secondary q-px-sm q-py-xs"
            no-caps
            flat
            @click="
              $router.push(
                `${$route.path.split('goalSummary')[0]}dataSummary${
                  $route.path.split('goalSummary')[1]
                }`
              )
            "
          >
            <span class="text-white"> Back</span>
          </q-btn>
          <q-btn
            v-else
            class="bg-secondary q-px-sm q-py-xs"
            no-caps
            flat
            @click="
              $router.push(
                `${$route.path.split('goalSummary')[0]}dataUpload${
                  $route.path.split('goalSummary')[1]
                }`
              )
            "
          >
            <span class="text-white"> Back </span>
          </q-btn>
        </div>
      </div>
      <div style="width: 25%">
        <side-bar class="sidebar_wrapper" style="height: calc(100vh - 60px)">
          <div class="column full-height full-width sidebar">
            <div class="col-auto q-px-lg" style="height: calc(109px)">
              <div class="row full-height items-center">
                <span class="goalSummary-title">
                  {{
                    goalSummary.goalBuilderGoal ||
                    goalSummary.basicGoals.length > 0
                      ? "Goal Summary"
                      : "Data Goal Summary"
                  }}
                </span>
              </div>
            </div>
            <div class="col-auto q-pa-lg" style="height: calc(100vh - 226px)">
              <div v-if="goalSummary.goalBuilderGoal">
                <div v-if="!goalSummary.goalBuilderGoal.writeYourOwnGoal">
                  <div class="row">
                    <span class="title"
                      >To
                      {{
                        goalSummary.goalBuilderGoal.action[0].toLowerCase() +
                        goalSummary.goalBuilderGoal.action.slice(1)
                      }}
                      use of</span
                    >
                  </div>
                  <div class="row">
                    <div>
                      <span class="goal-title">{{
                        goalSummary.sourceData.name
                      }}</span>
                      <br />
                      <span class="goal-title">
                        by
                        {{ goalSummary.goalBuilderGoal.reductionPercentage }}%
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="title">
                      before the end of
                      {{ goalSummary.goalBuilderGoal.due_at.split("-")[0] }}
                    </span>
                  </div>
                  <div class="row q-mt-lg">
                    <span class="title2">Which will save</span>
                  </div>
                  <div class="row">
                    <span class="goal-title">
                      {{
                        calculateSavings(
                          goalSummary.goalBuilderGoal.baselineData,
                          goalSummary.goalBuilderGoal.reductionPercentage
                        )
                      }}
                      {{ goalSummary.sourceData.unit }}
                    </span>
                  </div>
                  <!--SPECIAL UNIT GOES HERE-->
                  <div
                    class="row q-mt-sm"
                    v-if="getFactoredAmount(goalSummary)"
                  >
                    <span class="title2">and</span>
                  </div>
                  <div class="row">
                    <span
                      class="goal-title"
                      v-if="getFactoredAmount(goalSummary)"
                    >
                      {{
                        factorCalculation(
                          calculateSavings(
                            getFactoredAmount(goalSummary),
                            goalSummary.goalBuilderGoal.reductionPercentage
                          )
                        ) | numberFormat
                      }}
                      {{
                        factorUnit(
                          filteredData[0]
                            ? filteredData[0].emissionsFactor[0].unit
                            : ""
                        )
                      }}
                    </span>
                  </div>
                  <div class="row justify-center">
                    <q-separator class="q-mt-md" style="width: 200px" />
                  </div>

                  <div
                    class="row q-mt-md emissionsFactorText"
                    v-if="
                      !getLatestFactorToTheSelectedYear(goalSummary.sourceData)
                        .blurb
                    "
                  >
                    <div
                      v-if="
                        getLatestFactorToTheSelectedYear(goalSummary.sourceData)
                          .emissionsFactor &&
                        filteredData[0] &&
                        filteredData[0].emissionsFactor[0] &&
                        !filteredData[0].emissionsFactor[0].hideBlurb
                      "
                    >
                      The emissions factor that we have used to determine your
                      {{
                        filteredData[0]
                          ? filteredData[0].emissionsFactor[0].unit
                          : ""
                      }}
                      for this source was
                      <strong>
                        {{
                          getLatestFactorToTheSelectedYear(
                            goalSummary.sourceData
                          ).emissionsFactor
                        }}
                        {{
                          getLatestFactorToTheSelectedYear(
                            goalSummary.sourceData
                          ).unit
                        }}</strong
                      >. Based off the NZ government detailed emissions guide
                      <a
                        v-if="
                          getLatestFactorToTheSelectedYear(
                            goalSummary.sourceData
                          ).url
                        "
                        style="color: #162c47; font-weight: 800"
                        :href="
                          checkUrl(
                            getLatestFactorToTheSelectedYear(
                              goalSummary.sourceData
                            ).url
                          )
                        "
                        target="_blank"
                      >
                        found here
                      </a>
                      . As at
                      <strong>
                        {{
                          getLatestFactorToTheSelectedYear(
                            goalSummary.sourceData
                          ).created_at | slashDate
                        }}
                      </strong>
                    </div>
                  </div>
                  <div v-else class="row emissionsFactorText">
                    {{ goalSummary.sourceData.blurb }}
                    <a
                      :href="checkUrl(goalSummary.sourceData.url)"
                      target="_blank"
                    >
                      found here
                    </a>
                  </div>
                </div>
                <div v-else>
                  <div class="row">
                    <span class="goal-title">
                      {{ goalSummary.goalBuilderGoal.writeYourOwnGoal }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-else-if="goalSummary.basicGoals.length > 0">
                <div class="row">
                  <span class="title">
                    {{
                      formatPreWrittenGoalText(goalSummary.basicGoals[0])
                        .normalText
                    }}
                  </span>
                </div>
                <div class="row">
                  <span class="goal-title">
                    {{
                      formatPreWrittenGoalText(goalSummary.basicGoals[0])
                        .coloredText
                    }}
                  </span>
                </div>
              </div>
              <div v-else>
                Welcome to your <b class="highlight">Data Goals page.</b>
                <br /><br />
                Firstly, set an overall goal and then set specific goals against
                your sources you’ve entered data for.
              </div>
            </div>
            <div class="col q-px-md">
              <q-btn
                class="q-px-sm q-py-xs button-bg float-right"
                no-caps
                flat
                @click="$router.push('/workspace/' + selectedOutcome.id)"
              >
                <span class="button-next-steps text-white"> Next </span>
              </q-btn>
            </div>
          </div>
          <div class="row justify-end q-px-md" style="margin-top: 100px"></div>
        </side-bar>
      </div>
    </div>

    <q-dialog v-model="overallTargetSelectorDialog">
      <set-overall-target-form
        :outcome="selectedOutcome"
        assessmentTool="data"
        :closeFunction="
          () => {
            overallTargetSelectorDialog = false;
          }
        "
      />
    </q-dialog>
    <q-dialog v-model="goalBuilderDialog" persistent>
      <goal-builder
        :outcomeColor="selectedOutcome.primaryColor"
        :outcomeColorSecondary="selectedOutcome.secondaryColor"
        @closeDialog="closeGoalBuilderDialog"
        defaultTab="goalBuilder"
        @callGoalSummaryInit="init"
        :selectedSource="selectedSource"
      ></goal-builder>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
import { getMonths } from "@/functions/getMonths";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import Topbar from "@/components/topbar/topbar.vue";
import SideBar from "@/components/sidebar/sidebar.vue";
import moment from "moment";
import GoalBuilder from "@/components/goalBuilder/goalBuilder.vue";
import YearPicker from "@/components/generalComponents/yearPicker.vue";
import SummaryStatsCard from "@/components/generalComponents/summaryStatsCard.vue";
import SetOverallTargetForm from "@/components/businessTargets/SetOverallTargetForm.vue";

export default {
  components: {
    SustainabilityDataTable,
    Topbar,
    SustainabilityDropdown,
    SideBar,
    GoalBuilder,
    YearPicker,
    SummaryStatsCard,
    SetOverallTargetForm,
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters({
      currentUserData: "auth/currentUserData",
      outcomesList: "outcomes/list",
      outcomesCategories: "outcomes/categories/listForData",
      data: "sources/data/list",
      businessExtra: "businessExtra/data",
      businessTargets: "businessTargets/list",
    }),

    categoryKeys() {
      let categoryKeys = {};
      this.data.forEach((e) => {
        if (e.total) {
          categoryKeys[e.categories_id] = true;
        }
      });

      return categoryKeys;
    },
    summaryStatsCardSlides() {
      // This is deciding what Unit to use (If there is an override on the outcome or not.)
      let unit = this.selectedOutcome.factorUnitDisplay
        ? this.selectedOutcome.factorUnitDisplay
        : this.filteredData[0]
        ? this.filteredData[0].emissionsFactor[0].unit
        : "";
      let factorMultiplier = this.selectedOutcome.factorMultiplier
        ? this.selectedOutcome.factorMultiplier
        : 1;
      let intensity =
        this.businessExtra && this.businessExtra.annualRevenue
          ? this.$options.filters.numberFormat(
              (this.calculateTotalEmissionsBasedOnData * factorMultiplier) /
                (this.businessExtra.annualRevenue / 1000000)
            )
          : 0;

      let businessTargetContent =
        this.businessTargets && this.businessTargets.data
          ? `From <b>${this.$options.filters.numberFormat(
              this.businessTargets.data.baseLineData
            )} ${this.factorUnit(
              this.businessTargets.data.baseLineUnit
            )}</b> <br /> to <b>${this.$options.filters.numberFormat(
              this.businessTargets.data.targetData
            )} ${this.factorUnit(this.businessTargets.data.baseLineUnit)}</b>`
          : `Please Set an Overall Target for ${this.selectedOutcome.label}`;
      let businessReduceContent =
        this.businessTargets && this.businessTargets.data
          ? `Reduce by ${
              this.businessTargets.data.reducePercent
            }% (${this.$options.filters.numberFormat(
              this.businessTargets.data.baseLineData -
                this.businessTargets.data.targetData
            )} ${this.factorUnit(this.businessTargets.data.baseLineUnit)})`
          : ``;
      let slides = [
        {
          cardTitle: `${this.selectedOutcome.label} (${unit})`,
          cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${this.$options.filters.numberFormat(
            this.calculateTotalEmissionsBasedOnData * factorMultiplier
          )} <span style='font-size: 14px; font-weight: 800'>(${unit})</span></h3>`,
          subContent: `<span style='color: ${this.cssVars["--outcome-primary"]}'>based on your current data entries</span>`,
          action: {
            emit: "setOverallTarget",
            text: true,
            underlined: true,
            label: "Set Target",
          },
        },
        {
          cardTitle: `Your Overall Target`,
          cardMainContent: `<h3 class='q-ma-none' style='font-size: 1rem; line-height: 1.0rem; font-weight: 400; margin: 0'>
                                                                                                                                      ${businessTargetContent}
                                                                                                                                        `,
          subContent: `<span style='color: ${this.cssVars["--outcome-primary"]}'>${businessReduceContent}</span>`,
          action: {
            emit: "setOverallTarget",
            text: true,
            underlined: true,
            label: "Set Target",
          },
        },
        {
          cardTitle: `Your ${this.selectedOutcome.label} Intensity`,
          cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${intensity} <span style='font-size: 14px; font-weight: 800'>${unit}/$1M</span></h3>`,
          subContent: `<span style='color: ${
            this.cssVars["--outcome-primary"]
          }'>based on $${this.$options.filters.numberFormat(
            this.businessExtra.annualRevenue
          )} gross revenue</span>`,
          action: {
            emit: "setOverallTarget",
            text: true,
            underlined: true,
            label: "Set Target",
          },
        },
      ];
      return slides;
    },
    calculateTotalEmissionsBasedOnData() {
      let totalEmissions = 0;
      if (this.filteredData.length > 0) {
        this.filteredData.forEach((e) => {
          if (!e.external && e.emissionsFactor.length > 0) {
            totalEmissions += this.getTotalDefaultEmission(e);
          } else if (e.external && e.customEmissionsFactor) {
            if (!isNaN(parseFloat(e.customEmissionsFactor.totalValue))) {
              totalEmissions += parseFloat(e.customEmissionsFactor.totalValue);
            }
          }
        });
      }
      return totalEmissions;
    },
    formattedSelectedYear() {
      if (typeof this.selectedYear === "string") {
        return this.selectedYear.split("/")[0];
      } else {
        return this.selectedYear;
      }
    },
    cssVars() {
      let primaryColorFaded = this.selectedOutcome.primaryColor
        ? this.selectedOutcome.primaryColor.split("#")
        : ["", "162c47"];
      let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
      return {
        "--outcome-primary": this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor
          : "#162c47",
        "--outcome-secondary": this.selectedOutcome.secondaryColor
          ? this.selectedOutcome.secondaryColor
          : "#162c47",
        "--outcome-tertiary": this.selectedOutcome.tertiaryColor
          ? this.selectedOutcome.tertiaryColor
          : "#162c47",
        "--outcome-primary-faded": primaryColorFadedString,
      };
    },
    columns() {
      let currentColumns = [
        {
          name: "sourceName",
          label: "Source",
          align: "left",
          field: "name",
          boldItems: true,
          capsHeader: true,
          boldHeader: true,
          headerTextStyle: `color:${this.cssVars["--outcome-secondary"]}!important;`,
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },

        {
          name: "total",
          label: "Total",
          align: "left",
          field: "total",
          boldHeader: true,
          headerTextStyle: `font-family: 'Montserrat';font-style: normal;font-weight: 700;font-size: 14px;color:${this.cssVars["--outcome-secondary"]}!important;`,
          extendedCSS:
            "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 10px;margin-left: 2px;",
          style:
            "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
      ];
      if (this.selectedOutcome.id) {
        currentColumns.slice(2);
      }

      if (this.selectedOutcome.usesFactor) {
        currentColumns.push({
          name: "emissionsFactor",
          label: `${
            this.filteredData[0]
              ? this.factorUnit(this.filteredData[0].emissionsFactor[0].unit)
              : ""
          }`,
          align: "left",
          field: "emissionsFactor",
          boldHeader: true,
          headerTextStyle: `font-family: 'Montserrat';font-style: normal;font-weight: 700;font-size: 14px;color:${this.cssVars["--outcome-secondary"]}!important;`,
          extendedCSS:
            "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 10px;margin-left: 2px;",
          style:
            "min-width: 110px;max-width: 110px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          format: (val, row) => {},
        });
      }

      currentColumns.push({
        name: "actions",
        label: "",
      });

      return currentColumns;
    },
    formattedDateFrom() {
      if (this.dateFrom != "") {
        return moment(this.dateFrom).format();
      }
    },
    filteredData() {
      let currentData = this.data;
      currentData = currentData.filter((e) => e.total);
      currentData = currentData.map((e) => {
        if (this.isUseCustomEmissionsFactor(e)) {
          return { ...e, external: true };
        } else {
          return { ...e, external: false };
        }
      });
      currentData = currentData
        .filter((e) => {
          if (this.selectedCategory == "all") {
            return e;
          } else {
            if (e.categories_id == this.selectedCategory.id) {
              return e;
            }
          }
        })
        .sort((a, b) => (a.rank > b.rank ? 1 : -1));

      return currentData;
    },
    filteredCategories() {
      return this.outcomesCategories.sort((a, b) => (a.rank > b.rank ? 1 : -1));
    },
  },
  data: () => ({
    tab: "",

    //filtering
    selectedOutcome: null,
    selectedCategory: "all",

    //dialog
    dataDialog: false,
    newData: false,
    sourceName: null,
    sourceId: null,
    overallTargetSelectorDialog: false,

    //selected year
    selectedYear: null,
    yearDialog: false,

    //mode
    isLockMode: true,

    //goal builder dialog
    goalBuilderDialog: false,
    selectedSource: null,

    //goal summary
    goalSummary: {
      goalBuilderGoal: null,
      basicGoals: [],
    },
  }),
  watch: {
    $route: {
      handler() {
        this.handleRoute();
      },
      deep: true,
    },
  },
  methods: {
    isUseCustomEmissionsFactor(row) {
      if (row.customEmissionsFactor) {
        if (row.customEmissionsFactor.useCustom) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // calculateTotalEmissionsBasedOnData() {
    //   let totalEmissions = 0;
    //   if (this.filteredData.length > 0) {
    //     this.filteredData.forEach((e) => {
    //       if (!e.external && e.emissionsFactor.length > 0) {
    //         totalEmissions += this.getTotalDefaultEmission(e);
    //       } else if (e.external && e.customEmissionsFactor) {
    //         if (!isNaN(parseFloat(e.customEmissionsFactor.totalValue))) {
    //           totalEmissions += parseFloat(e.customEmissionsFactor.totalValue);
    //         }
    //       }
    //     });
    //   }
    //   return totalEmissions;
    // },
    getTotalDefaultEmission(data) {
      //get the chosen year
      let selectedYear =
        typeof this.selectedYear == "number"
          ? this.selectedYear
          : parseFloat(this.selectedYear.split("/")[0]);
      if (data.emissionsFactor.length > 0) {
        //get the latest emissions factor of the selected year
        let latestEmissionFactor = data.emissionsFactor[0];

        data.emissionsFactor.forEach((e) => {
          if (parseFloat(e.created_at.split("-")[0]) <= selectedYear) {
            latestEmissionFactor = { ...e };
          }
        });

        if (latestEmissionFactor.unit.toLowerCase() == "kgco2-e") {
          return (
            (parseFloat(data.total) *
              parseFloat(latestEmissionFactor.emissionsFactor)) /
            1000
          );
        } else {
          return (
            parseFloat(data.total) *
            parseFloat(latestEmissionFactor.emissionsFactor)
          );
        }
      }
    },
    formatPreWrittenGoalText(goal) {
      let normalText = goal.basicGoalAction.split(goal.basicGoal);

      if (normalText.length > 0) {
        let coloredText = goal.basicGoalAction.split(normalText[0]);
        return {
          normalText: normalText[0],
          coloredText: coloredText[1],
        };
      }
    },
    convertTotalToTotalEmissions(data) {
      let latestFactor = this.getLatestFactorToTheSelectedYear(data);
      if (latestFactor.emissionsFactor) {
        return parseFloat(data.total * latestFactor.emissionsFactor);
      } else {
        return null;
      }
    },
    getLatestFactorToTheSelectedYear(data) {
      let selectedYear =
        typeof this.selectedYear == "number"
          ? this.selectedYear
          : parseFloat(this.$route.params.year);
      if (data.emissionsFactor.length > 0) {
        let latestEmissionFactor = data.emissionsFactor[0];
        data.emissionsFactor.forEach((e) => {
          if (parseFloat(e.created_at.split("-")[0]) <= selectedYear) {
            latestEmissionFactor = { ...e };
          }
        });
        return latestEmissionFactor;
      } else {
        return {
          emissionsFactor: null,
          unit: null,
        };
      }
    },
    initGoalSummary(data) {
      this.goalSummary = {
        sourceData: data,
        goalBuilderGoal: data.goalBuilderGoal,
        basicGoals: [],
      };
      if (data.goalBuilderGoal) {
        if (data.goalBuilderGoal.basicGoals_id) {
          this.goalSummary.goalBuilderGoal = null;
          this.goalSummary.basicGoals.push(data.goalBuilderGoal);
        }
      }
    },
    isGoalSet(data) {
      if (data.goalBuilderGoal) {
        return true;
      } else {
        return false;
      }
    },
    calculateSavings(total, percentage) {
      return (total * percentage) / 100;
    },
    checkUrl(url) {
      if (!url.includes("http")) {
        return "https://" + url;
      } else {
        return url;
      }
    },
    init() {
      this.selectedYear = this.$route.params.year
        ? this.$route.params.year
        : this.$moment().format("YYYY");
      this.$router.push(
        `${this.$route.path.split("/year")[0]}/year/${this.selectedYear}`
      );
      this.$store.dispatch("outcomes/loadAll").then((e) => {
        if (this.outcomesList.length > 0) {
          this.tab = this.outcomesList[0].name;
          if (this.$route.params.hasOwnProperty("outcomesID")) {
            let index = this.outcomesList.findIndex(
              (o) => this.$route.params.outcomesID == o.id
            );

            this.selectedOutcome = this.outcomesList[index];
          } else {
            this.selectedOutcome = this.outcomesList[0];
          }

          this.$store.dispatch(
            "outcomes/categories/loadAllByOutcomesID",
            this.selectedOutcome.id
          );

          this.initDataWithGoals();
          this.handleRoute();
        }
      });
    },
    async openGoalBuilder(data) {
      this.selectedSource = data;
      this.$router.push(this.$route.path + "/source/" + data.sources_id);
    },
    async handleRoute() {
      if (this.$route.params.hasOwnProperty("sourceID")) {
        this.$store.dispatch("sources/data/loadBySourceID", {
          id: this.$route.params.sourceID,
        });
        await this.$store.dispatch(
          "basicGoals/loadBySourceIDWithStatusLive",
          this.$route.params.sourceID
        );
        this.goalBuilderDialog = true;
      }
    },
    closeGoalBuilderDialog() {
      this.$router.push(`${this.$route.path.split("/source")[0]}`);
      this.goalBuilderDialog = false;
      this.initDataWithGoals();
    },
    getOutcomeImage: getOutcomeImage,
    getMonths: getMonths,
    checkCalendar(val) {
      this.selectedYear = val.split("/")[0];
      this.$router.push(
        `${this.$route.path.split("/year")[0]}/year/${this.selectedYear}`
      );
      this.initDataWithGoals();
    },
    getTotalOfRowData(row) {
      let total = 0;
      let arrayOfKeys = Object.keys(row);
      arrayOfKeys.forEach((e) => {
        if (this.getMonths().includes(e)) {
          if (!isNaN(parseFloat(row[e]))) {
            total += parseFloat(row[e]);
          }
        }
      });
      return `${total}`;
    },
    selectOutcome(outcome) {
      this.$router.push(
        `${this.$route.path.split("outcome/")[0]}outcome/${
          outcome.id
        }/goalSummary`
      );
      this.selectedOutcome = { ...outcome };

      this.$store.dispatch(
        "outcomes/categories/loadAllByOutcomesID",
        this.selectedOutcome.id
      );
      this.initDataWithGoals();
      this.$forceUpdate();
      this.goalSummary = {
        goalBuilderGoal: null,
        basicGoals: [],
      };
    },
    initDataWithGoals() {
      this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
        id: this.selectedOutcome.id,
        year: this.selectedYear,
      });
    },
    getNumberOfDataByCategory(categoryID) {
      return this.data.filter((e) => e.categories_id == categoryID).length;
    },
    handleDoubleClick(row) {
      if (row.sourcesData_id) {
        this.$store.dispatch("sources/loadSourcesDataByID", row.sourcesData_id);
        this.newData = false;
      } else {
        this.newData = true;
      }
      this.sourceName = row.sourceName;
      this.sourceId = row.sources_id;
      this.$nextTick(() => {
        this.dataDialog = true;
      });
    },
    async saveData() {
      if (!this.isLockMode) {
        this.isLockMode = true;
        let payload = {
          year: this.selectedYear,
          sourcesData: this.$refs.dtable.data,
        };
        let result = await this.$store.dispatch("sources/data/save", payload);
        this.$store.dispatch("units/loadAll");

        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },
    filterCategory(category) {
      this.selectedCategory = category;
    },
    setOverallTarget() {
      this.overallTargetSelectorDialog = true;
    },
    async submitData(sourcesData) {
      sourcesData.date_from = moment(this.dateFrom).format("YYYY-MM-DD");
      sourcesData.date_to = moment(this.dateTo).format("YYYY-MM-DD");
      let result = null;
      if (sourcesData.total || sourcesData.unit) {
        if (isNaN(parseFloat(sourcesData.total))) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Please provide a Numerical value",
          });
          return;
        }
      }
      if (sourcesData.sourcesData_id) {
        result = await this.$store.dispatch(
          "sources/saveSourcesData",
          sourcesData
        );
      } else {
        if (sourcesData.total || sourcesData.unit) {
          result = await this.$store.dispatch(
            "sources/newSourcesData",
            sourcesData
          );
        }
      }
      if (result) {
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },

    getFactoredAmount(goal) {
      if (goal.goalBuilderGoal.customFactorData) {
        return goal.goalBuilderGoal.customFactorData;
      }
      return this.convertTotalToTotalEmissions(goal.sourceData);
    },

    factorCalculation(data) {
      if (
        this.selectedOutcome &&
        this.selectedOutcome.factorMultiplier &&
        data
      ) {
        return data * this.selectedOutcome.factorMultiplier;
      } else {
        return data;
      }
    },
    factorUnit(data) {
      if (this.selectedOutcome && this.selectedOutcome.factorUnitDisplay) {
        return this.selectedOutcome.factorUnitDisplay;
      } else {
        return data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/*SIDEBAR*/
.sidebar_wrapper {
  background-color: #f6f6f6;
  font-family: "Montserrat";
  font-style: normal;

  .goalSummary-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    color: var(--outcome-secondary);
  }

  .highlight {
    color: var(--outcome-secondary);
  }

  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
  }

  .title2 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 10.1305px;
  }

  .goal-title {
    font-family: "Montserrat";
    font-style: normal;
    font-size: 20.5369px;
    font-weight: 900;
    color: var(--outcome-primary);
  }

  .emissionsFactorText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
  }
}

.value {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  text-align: right;
}

.button-bg {
  background-color: var(--outcome-secondary) !important;
}
.emission {
  font-family: "Montserrat";
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 400;
  font-size: 14px;
  color: var(--outcome-secondary);
}

.unit {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}

/*button*/
.buttons {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 9px;
}

/*topbar */
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
}

/*year dropdown*/
.dropdownYear {
  background-color: rgba(0, 0, 0, 0.27);
  border-radius: 5px;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 10px;
  padding-right: 10px;
}
.label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: white;
  margin-right: 10px;
}

.dropdownTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

.dropdownValue {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
}

/*end of top bar css*/
.unit-input-label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}

.unit-input-label-bold {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
}
.page-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: var(--outcome-secondary);
}

.set-time-period {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;

  .icon {
    color: #162c47;
    font-size: 30px;
  }

  .dateFrom {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 15px;
    color: #37235f;
  }

  .to {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    color: #162c47;
  }

  .dateTo {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 15px;
    color: #4ac7e9;
  }
}

.categoryCard {
  margin-bottom: 20px;

  .categoryText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
  }
}

.categoryHeader {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: var(--outcome-primary);
}

.cardSelected {
  background-color: var(--outcome-primary-faded);
}

.sustainability-card-radius {
  border-radius: 10px;
}

.subtitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
}

.columnLabel {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
  text-transform: uppercase;
}

.outcome-theme-primary {
  background-color: var(--outcome-primary);
}

.outcome-theme-secondary {
  background-color: var(--outcome-secondary);
}

.set-year-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}

.grid-buttons {
  width: 122px;
  height: 34px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
}

.category-number {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: rgba(5, 0, 0, 0.5);
}

.sourceColumn-div {
  width: 190px;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.sourceColumn {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  overflow: hidden;
  color: var(--outcome-secondary);
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.totalColumn-unit {
  margin-left: 20px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}
.totalColumn-div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: none;
  display: inline;
}

.dataInput-div {
  width: 140px;
}

.scrollbar-style ::-webkit-scrollbar {
  width: 10px;
}
</style>
